import React from 'react';

const getQuestionTitle = (block: any, questions: any) => {
  return questions.find((q: any) => q.name === block.question_names[0])?.text;
};

export type BlockItemComponentProps = {
  currentBlock: any;
  surveyForm: any;
  blocks?: any;
};
export const BlockItemComponent = ({
  currentBlock,
  surveyForm,
  blocks,
}: BlockItemComponentProps) => {
  return (
    <div className="dropdown-item">
      <div>
        {currentBlock?.title === 'Thank you'
          ? 'End Survey'
          : currentBlock?.title}
      </div>
      <div
        className="block-question-text"
        dangerouslySetInnerHTML={{
          __html: getQuestionTitle(
            (blocks || surveyForm.meta.blocks).find(
              (b: any) => b.name === currentBlock.name,
            ),
            surveyForm.question_details.questions,
          ),
        }}
      ></div>
    </div>
  );
};

export default BlockItemComponent;
